export class SrdUser {
  id: number;
  contactPerson: string;
  clientOrganization: string;
  branch: string;
  userEmail: string;
  userPassword: string;
  gender: string;
}